/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FactsAboutWeatherProtection,
  FactsAboutWeatherProtectionDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiFactsAboutWeatherProtectionProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<FactsAboutWeatherProtection>(
      {url: `/api/FactsAboutWeatherProtection/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiFactsAboutWeatherProtectionProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/FactsAboutWeatherProtection/${projectId}`
    ] as const;
    }


export const getGetApiFactsAboutWeatherProtectionProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiFactsAboutWeatherProtectionProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>> = ({ signal }) => getApiFactsAboutWeatherProtectionProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiFactsAboutWeatherProtectionProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>>
export type GetApiFactsAboutWeatherProtectionProjectIdQueryError = ErrorType<unknown>


export function useGetApiFactsAboutWeatherProtectionProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiFactsAboutWeatherProtectionProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiFactsAboutWeatherProtectionProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiFactsAboutWeatherProtectionProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutWeatherProtectionProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiFactsAboutWeatherProtectionProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiFactsAboutWeatherProtection = (
    factsAboutWeatherProtectionDto?: BodyType<FactsAboutWeatherProtectionDto>,
 signal?: AbortSignal
) => {


      return customInstance<FactsAboutWeatherProtection>(
      {url: `/api/FactsAboutWeatherProtection`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: factsAboutWeatherProtectionDto, signal
    },
      );
    }




export const getPutApiFactsAboutWeatherProtectionMutationKey = () => ['putApiFactsAboutWeatherProtection'] as const;

export const getPutApiFactsAboutWeatherProtectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>, TError,PutApiFactsAboutWeatherProtectionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>, TError,PutApiFactsAboutWeatherProtectionMutationVariables, TContext> => {

const mutationKey = getPutApiFactsAboutWeatherProtectionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>, PutApiFactsAboutWeatherProtectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiFactsAboutWeatherProtection(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiFactsAboutWeatherProtectionMutationResult = NonNullable<Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>>
    export type PutApiFactsAboutWeatherProtectionMutationBody = BodyType<FactsAboutWeatherProtectionDto> | undefined
    export type PutApiFactsAboutWeatherProtectionMutationError = ErrorType<unknown>
    export type PutApiFactsAboutWeatherProtectionMutationVariables = {data?: BodyType<FactsAboutWeatherProtectionDto>}

    export const usePutApiFactsAboutWeatherProtection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>, TError,PutApiFactsAboutWeatherProtectionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiFactsAboutWeatherProtection>>,
        TError,
        PutApiFactsAboutWeatherProtectionMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiFactsAboutWeatherProtectionMutationOptions(options), queryClient);
    }
